/**
 *@format
 */
import { api } from '@/scripts/api';

export const MDFAgencyPreapprovedFundService = {
    post(accountId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/preapproved-funds/vendor-account/${accountId}`;

            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    patch(accountId, preApprovedFundId, payload) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/preapproved-funds/vendor-account/${accountId}/${preApprovedFundId}`;
            api.msPatch(service, payload).then(resolve).catch(reject);
        });
    },

    getPreApproved({ agencyAccountId, preApprovedFundId }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/preapproved-funds/vendor-account/${agencyAccountId}/${preApprovedFundId}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getAllPreapprovedFunds({ accountId, config = '' }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/preapproved-funds/vendor-account/${accountId}/count?${config}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getById(accountId, preapprovedFundId, clientId) {
        return new Promise((resolve, reject) => {
            const service = clientId
                ? `/ms/marketing-development-funds/v1/preapproved-funds/client-account/${accountId}/${preapprovedFundId}`
                : `/ms/marketing-development-funds/v1/preapproved-funds/vendor-account/${accountId}/${preapprovedFundId}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getClientPreapprovedFunds({ clientAccountId, agencyAccountId, config = '' }) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/preapproved-funds/client-account/${clientAccountId}/agency-account/${agencyAccountId}?${config}`;
            api.get(service).then(resolve).catch(reject);
        });
    },

    getBalance(accountId, clientAccountId) {
        return new Promise((resolve, reject) => {
            const service = `/ms/marketing-development-funds/v1/preapproved-funds/client-account/${clientAccountId}/vendor-account/${accountId}/balance`;

            api.get(service).then(resolve).catch(reject);
        });
    },

    async getPreapprovedFundIds(accountId) {
        const service = `/ms/marketing-development-funds/v1/preapproved-funds/vendor-account/${accountId}/select/ids`;
        return api.get(service);
    },

    async exportPreapprovedFundsCsv({ accountId, ids }) {
        const service = `/ms/marketing-development-funds/v1/preapproved-funds/vendor-account/${accountId}/export/csv`;
        const payload = { ids };

        return api.post(service, payload);
    },
};
